import { render, staticRenderFns } from "./NonLoginBusinessMatchContent.vue?vue&type=template&id=04c7ff92&scoped=true"
import script from "./NonLoginBusinessMatchContent.vue?vue&type=script&lang=ts"
export * from "./NonLoginBusinessMatchContent.vue?vue&type=script&lang=ts"
import style0 from "./NonLoginBusinessMatchContent.vue?vue&type=style&index=0&id=04c7ff92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c7ff92",
  null
  
)

export default component.exports